// Reusable component for displaying validation warnings/badges
export function ItemValidationBadges({ item, compact = false }) {
  const flags = summarizeFlags(item?.triage_flags || {})
  const warnings = []

  // Check required fields for approval
  if (!item?.proposed_admin_title || item.proposed_admin_title.match(/^(q\d+|new question|untitled|placeholder)$/i)) {
    warnings.push({ type: 'title', label: 'missing title' })
  }
  if (!item?.proposed_category_id) {
    warnings.push({ type: 'category', label: 'missing category' })
  }
  if (!item?.proposed_vtne_domain_id) {
    warnings.push({ type: 'domain', label: 'missing VTNE domain' })
  }
  if (!item?.proposed_rationale || item.proposed_rationale.trim().length < 10) {
    warnings.push({ type: 'rationale', label: 'missing rationale' })
  }

  const allWarnings = [...warnings, ...flags.map(f => ({ type: 'flag', label: f }))]

  if (allWarnings.length === 0) {
    return <div style={{ fontSize: 12, color: '#86efac' }}>✓ Ready for approval</div>
  }

  if (compact) {
    return (
      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        {allWarnings.slice(0, 2).map((w, i) => (
          <span key={i} style={{
            background: w.type === 'flag' ? '#3f2c06' : '#450a0a',
            color: w.type === 'flag' ? '#fcd34d' : '#fca5a5',
            padding: '2px 6px',
            borderRadius: 4,
            fontSize: 11,
          }}>
            {w.label}
          </span>
        ))}
        {allWarnings.length > 2 && (
          <span style={{ fontSize: 11, color: '#94a3b8' }}>+{allWarnings.length - 2} more</span>
        )}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {allWarnings.map((w, i) => (
        <span key={i} style={{
          background: w.type === 'flag' ? '#3f2c06' : '#450a0a',
          color: w.type === 'flag' ? '#fcd34d' : '#fca5a5',
          padding: '4px 8px',
          borderRadius: 4,
          fontSize: 12,
        }}>
          {w.label}
        </span>
      ))}
    </div>
  )
}

function summarizeFlags(flags = {}) {
  const pairs = [
    ['invalid_choice_count', value => value ? `${value} bad choices` : null],
    ['missing_correct_answer', value => value ? 'missing correct answer' : null],
    ['duplicate_suspect', value => value ? 'possible duplicate' : null],
    ['all_of_the_above', value => value ? 'all of above answer' : null],
    ['true_false', value => value ? 'true/false format' : null],
  ]
  return pairs.map(([key, format]) => format(flags[key])).filter(Boolean)
}
